// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__10hZF","colCheckbox":"styles_colCheckbox__10eWw"};